import React from 'react';
import classnames from 'classnames';
import { getItemKey } from "../../util/index.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function BasicRowRenderer(props) {
  const {
    rows,
    itemKey,
    ...rest
  } = props;
  return rows?.map((row, index) => {
    const key = getItemKey(row, index, itemKey);
    return /*#__PURE__*/_jsx(Row, {
      row: row,
      index: index,
      ...rest
    }, key);
  }) || null;
}
function Row({
  row,
  index,
  prepareRow,
  rowClassName,
  evenRowClassName,
  oddRowClassName,
  cellClassName,
  getRowProps
}) {
  if (!row) {
    return null;
  }
  prepareRow(row);
  const isEven = (index + 1) % 2 === 0;
  return /*#__PURE__*/_jsx("div", {
    ...row.getRowProps(getRowProps(row, {
      className: classnames(rowClassName, isEven ? evenRowClassName : oddRowClassName)
    })),
    children: row.cells.map(cell => {
      return /*#__PURE__*/_jsx("div", {
        ...cell.getCellProps({
          className: cellClassName
        }),
        children: cell.render('Cell')
      });
    })
  });
}